import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#0AA1F4'
        d='M8 14.667A6.666 6.666 0 118 1.334a6.666 6.666 0 010 13.333zm0-1.333A5.333 5.333 0 108 2.667a5.333 5.333 0 000 10.667zM8.666 8h2.667v1.334h-4V4.667h1.333V8z'
      ></path>
    </svg>
  )
}

export default Icon
